import Reports from '../../../../templates/views/Reports/Reports';
import store from 'dashboard/store';
import {ROLE_REPORTS} from "../../../../store/user/role-tree";

export default {
  path: 'reports',
  component: Reports,
  name: 'Reports',
  meta: {
    title: 'Reports',
    loggedInOnly: true
  },
  async beforeEnter(to, from, next) {
    if (store.getters['user/isGranted'](ROLE_REPORTS)) {
      next();
    } else {
      next(from.path);
    }
  },
};

